export default __webpack_public_path__ + "static/media/fina.92edc8d9.png";